module.exports = __webpack_public_path__ + "img/down-arrow.94e94e2d.png";